import { Helmet } from "react-helmet";
import { Navigate } from "react-router-dom";
import { Box } from "@chakra-ui/react";

import "./marketing.css";
import { useAuthentication } from "../../wrappers/UseAuthentication";

import LandingNavbar from "../landing/components/LandingNavbar";
import MarketingFooter from "./components/MarketingFooter";
import PageHero from "./components/PageHero";
import AboutMission from "./components/about/AboutMission";
import AboutWhatWeDo from "./components/about/AboutWhatWeDo";
import AboutFinalCta from "./components/about/AboutFinalCta";

const About = () => {
  const { isAuthenticated } = useAuthentication();
  if (isAuthenticated) return <Navigate to="/sales" replace />;

  return (
    <>
      <Helmet>
        <title>About — SpearBI</title>
        <meta
          name="description"
          content="Spearbi turns fragmented retailer feeds into one clear picture of your business. Meet the team behind the platform."
        />
      </Helmet>

      <Box
        bg="#ffffff"
        color="#0a0e1a"
        fontFamily="'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif"
        minH="100vh"
        overflowX="hidden"
        sx={{ WebkitFontSmoothing: "antialiased" }}
      >
        <LandingNavbar />
        <PageHero
          eyebrow="About Spearbi"
          title="Made for retail brands who refuse to fly blind."
          subtitle="We turn fragmented retailer feeds into one clear picture of your business — so you can make moves on Monday morning instead of waiting for end-of-month."
          height={520}
        />
        <AboutMission />
        <AboutWhatWeDo />
        {/* <AboutTeam /> — hidden until team photos are ready */}
        <AboutFinalCta />
        <MarketingFooter />
      </Box>
    </>
  );
};

export default About;
